import React from 'react';
import Section from './section';
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

const Projects = () => {
  const data = useStaticQuery(graphql`
    query ProjectsQuery {
      lifetools: file(absolutePath: { regex: "/projects\/lifetools.png/" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, aspectRatio: 2)
        }
      }
      countrycounting: file(absolutePath: { regex: "/projects\/countrycounting.png/" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, aspectRatio: 2)
        }
      }
      tothemean: file(absolutePath: { regex: "/projects\/tothemean-logo.png/" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, aspectRatio: 2)
        }
      }
    }
  `);

  return (
    <Section
      anchor='projects'
      title='Projects'
      subtitle='I like to build things'
      index={3}
      >

      <div className='columns'>
          <Item
            title='LifeTools'
            details="Free, fast calculators and converters for life's complicated stuff"
            url='https://lifetools.fyi'
            image={data.lifetools.childImageSharp.gatsbyImageData}
            />
          <Item
            title='tothemean'
            details='Blog and tools covering the crossover of sports and analytics'
            url='http://tothemean.com/'
            image={data.tothemean.childImageSharp.gatsbyImageData}
            />
          <Item
            title='countrycount.ing'
            details="Vote on what counts as a country and track where you've been"
            url='https://countrycount.ing'
            image={data.countrycounting.childImageSharp.gatsbyImageData}
            />
      </div>

    </Section>
  );
}

export default Projects;

const Item = ({title, details, image, url}) => {
  return (
    <div className='projects-item column is-one-third'>
      <div className='card'>
        <div className='card-image'>
          <a href={url}>
            <GatsbyImage
              as='figure'
              className='image img-hover'
              image={image}
              alt={title}
              style={{
                width: '100%',
              }}
              placeholder='none'
              sizes='(min-width: 769px) 33vw, 100vw'
            />
          </a>
        </div>
        <div className="card-content">
          <h4 className='title is-5'>
            <a href={url}>
              {title}
            </a>
          </h4>
          <p className='content'>{details}</p>
        </div>
      </div>
    </div>
  );
}
